import React, { useState } from 'react';

const MonthDropdown = ({ handleInputChange, name, errors, selectedMonth }) => {
  const [month, setMonth] = useState(selectedMonth || 'Month');
  

  return (
    <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
      <select
        id="field-2"
        name={name}
        data-name={name}
        className="select-field-3 w-select"
        style={{ width: '100%' }}
        value={month}
        onChange={(e) => {
          setMonth(e.target.value);
          handleInputChange(e);
        }}
      >
        <option value="Month">Month</option>
        <option value="January">January</option>
        <option value="February">February</option>
        <option value="March">March</option>
        <option value="April">April</option>
        <option value="May">May</option>
        <option value="June">June</option>
        <option value="July">July</option>
        <option value="August">August</option>
        <option value="September">September</option>
        <option value="October">October</option>
        <option value="November">November</option>
        <option value="December">December</option>
      </select>
      {errors && (
        <div className="error-message" style={{ color: '#CB112D',  width: '100%' }}>
          {errors}
        </div>
      )}
    </div>
  );
};

export default MonthDropdown;
